module.exports = __webpack_public_path__ + "img/USDC-ERC20.0dbb1031.png";